import { BaseAuthService } from "../base/baseApiAuth";
import { Login } from "../../models/LoginModel/login.model";

export class AuthService extends BaseAuthService {
  async Login(data: Login): Promise<any> {
    try {
      let URI = "users/login";
      const axiosResponse = await this.axiosClient.post(URI,data);
      return axiosResponse.data;
    } catch (e) {
      if (e?.response) {
        if (e.response?.status === 422) {
          const messages =
            e.response.data?.errors?.map((er) => {
              let name = er.field.split(".");
              name = name[name.length - 1];
              let message = "";
              switch (er.rule) {
                case "unique":
                  message = `El campo ${name} ya se encuentra registrado`;
                  break;
                default:
                  message = `EL campo ${name} es incorrecto`;
                  break;
              }
              return message.replace("", "");
            }) || [];
          return Promise.reject(messages);
        }
      }
      return Promise.reject(e.response.data??"Error al intentar iniciar");
    }
  }
}

export default new AuthService();
